import type { AnyAction, Dispatch, MiddlewareAPI } from '@reduxjs/toolkit'
import { gqlClient } from 'gql'
import { debounce } from 'lodash'

import { kUserPreferenceCacheUpdate } from 'gql/kusers/gql/cache'
import { updateUserPreferences } from 'gql/kusers/gql/mutations'

import { setUserPreferencesItems } from './reducer'

const updatePreferences = async (store: MiddlewareAPI, action: AnyAction) => {
  const state = store.getState()
  const userPreferences = state.users.userPreferences
  const userPreferencesItems = action.payload
  const newUserPreferences = { ...userPreferences, ...userPreferencesItems }
  const data = newUserPreferences
  const kUserId = state.users.meId
  kUserPreferenceCacheUpdate(kUserId, data)

  await gqlClient.core.mutate({
    mutation: updateUserPreferences,
    variables: { data },
  })
}

const debouncedUpdateUserPreferences = debounce(updatePreferences, 1000)

const preferencesMiddleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  if (action.type === setUserPreferencesItems.type) {
    debouncedUpdateUserPreferences(store, action)
  }

  return next(action)
}

export default preferencesMiddleware
